import React, { useState, useEffect } from 'react';
import { Pagination } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import cn from 'classnames';
import styled from './Pagination.module.scss';

type PaginationsProps = {
  baseComponentURL?: string;
  link?: string;
  className?: string;
  pageSize?: number;
  totalCount?: number;
};

// rename this function name to CustomPagination after all updates in all according components
const Paginations: React.FC<PaginationsProps> = ({
  baseComponentURL,
  link,
  className,
  pageSize = 20,
  totalCount = 0,
}) => {
  const [active, setActive] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  // created for backward compatibility with older components
  // link parameter should be replace by baseComponentURL parameter
  const baseURL = link ? `/${link}` : baseComponentURL;

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params && baseURL) {
      navigate(baseURL);
    }
  }, []);

  const onChange = (page: number) => {
    setActive(page);
    navigate(`${baseURL}?page=${page}&page_size=${pageSize}`);
    window.scrollTo({ top: 0 });
  };

  return (
    <div className={className}>
      {totalCount > pageSize && (
        <Pagination
          className={styled.pagination}
          pageSize={pageSize}
          total={totalCount}
          itemRender={(pageNumber, label, item) => {
            return (
              <span
                className={cn(
                  styled.pagination__item,
                  pageNumber === active && styled.pagination__item_active,
                )}
                title=""
              >
                {item}
              </span>
            );
          }}
          onChange={onChange}
          showSizeChanger={false}
        />
      )}
    </div>
  );
};

export default Paginations;
